'use client';
import type { Entry } from 'contentful';
import React, { useState, useEffect } from 'react';

import { useIsDesktop } from '@/hooks/useIsDesktop';
import {
  TypeVideoFields,
  TypeMuxVideoFields,
  TypeImageFields,
} from '@/core/generated-types';
import { Image } from '@/components/ui';

interface VideoSideBySideProps {
  mediaDesktop?: Entry<TypeVideoFields | TypeMuxVideoFields | TypeImageFields>;
  mediaMobile?: Entry<TypeVideoFields | TypeMuxVideoFields | TypeImageFields>;
}

const ImageSideBySide = ({
  mediaDesktop,
  mediaMobile,
}: VideoSideBySideProps) => {
  const isDesktop = useIsDesktop();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  const media = (
    isDesktop ? mediaDesktop : mediaMobile
  ) as Entry<TypeImageFields>;

  if (!hydrated) {
    return <div className="lg:w-1/2 relative bg-slate-300" />;
  }

  return (
    <div className="lg:w-1/2 relative">
      <Image
        imageData={media}
        className="w-full h-full object-cover aspect-square"
        alt="side by side media"
      />
    </div>
  );
};

export default ImageSideBySide;
